import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var GetReady = function GetReady(_target, _property, descriptor) {
  var noConfilt = descriptor.value;

  if (typeof noConfilt === 'function') {
    ;
    descriptor.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _len,
          args,
          _key,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof this['$$initialMethod'] === 'function')) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this['$$initialMethod']();

            case 3:
              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              return _context.abrupt("return", noConfilt.call.apply(noConfilt, [this].concat(args)));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  }

  return descriptor;
};